import React from 'react';
import { motion } from 'framer-motion';
import { InquiryForm } from './InquiryForm';
export function FinalCTA() {
  return <section id="future" className="relative w-full overflow-hidden bg-forest-dark" data-id="element-50" data-mp="3udp1evm5zus4">
      <img src="https://cdn.magicpatterns.com/uploads/74Ehbm2hXLTjc8CRmyWi4h/475527386_3867891260137664_2153653217832303475_n.png" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-10" data-id="element-51" data-mp="c7k4vvuvkjnt" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-5 py-20 lg:grid-cols-2 lg:px-8 lg:py-28" data-id="element-52" data-mp="h6djjrlwegpk">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} data-id="element-53" data-mp="vtq7fmz6gyj4">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-gold-light" data-id="element-54" data-mp="zua6iw3bac7w">
            Your Next Chapter
          </span>
          <h2 className="mt-3 font-display text-4xl leading-tight text-white sm:text-5xl" data-id="element-55" data-mp="2h37xky5u4kz3">
            The Future You Want Starts Here
          </h2>
          <p className="mt-6 max-w-lg font-serif text-lg leading-relaxed text-white/85" data-id="element-56" data-mp="2m1j717s7wtgs">
            Discover luxury independent living where you own your home, keep
            your healthcare choices, and live life entirely on your terms.
            Connect with a senior living specialist to schedule your private
            tour of our 50-acre community.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} data-id="element-57" data-mp="34u3v8bwz2ae9">
          <InquiryForm variant="light" data-id="element-58" data-mp="1jpembk3tbiw7" />
        </motion.div>
      </div>
    </section>;
}